/**
 * @generated SignedSource<<0dce44b3c01cb2cb77d131c177403910>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HorizontalNavBoardHeader_project$data = {
  readonly projectId?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs" | "extraComponentsFar_horizontalNav" | "ui_navigationBoardActionMenu_BoardActions">;
  readonly " $fragmentType": "HorizontalNavBoardHeader_project";
};
export type HorizontalNavBoardHeader_project$key = {
  readonly " $data"?: HorizontalNavBoardHeader_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"HorizontalNavBoardHeader_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "isTMPBoardRoute"
    }
  ],
  "kind": "Fragment",
  "name": "HorizontalNavBoardHeader_project",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "projectId"
        }
      ]
    },
    {
      "condition": "isTMPBoardRoute",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_navigationBoardActionMenu_BoardActions"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "extraComponentsFar_horizontalNav"
    },
    {
      "kind": "FragmentSpread",
      "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "389a8350795587f99c1237e003c6cda4";

export default node;
